function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "m807.5 1363.8 678.3 161.5v-1270.5l-678.3 161.5z",
  fill: "#205b97"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m1485.8 254.8 129.2 64.6v1141.3l-129.2 64.6zm-678.3 1109-678.3 161.5v-1270.5l678.3 161.5z",
  fill: "#5193ce"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m129.2 254.8-129.2 64.6v1141.3l129.2 64.6z",
  fill: "#205b97"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m979.8 1783.7 258.4-129.2v-1525.3l-258.4-129.2-79 847z",
  fill: "#5193ce"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m635.2 1783.7-258.4-129.2v-1525.3l258.4-129.2 79 847z",
  fill: "#205b97"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m635.2 0h348.1v1780.1h-348.1z",
  fill: "#2e73b7"
});

const SvgRs = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  enableBackground: "new 0 0 1615 1783.7",
  viewBox: "0 0 1615 1783.7",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRs, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/rs.3bd1a0f9.svg";
export { ForwardRef as ReactComponent };